module.exports = "/images/vendor/desiigner-svg/svg/social/facebook.svg?f60498a5d516672b86edcbf96bd4e52a";